<script setup>
import { nextTick } from 'vue';

// --------------------------------- Imports -------------------------------- //
const props = defineProps({
  columnConfig: {
    type: Object,
    default: () => ({}),
  },
  componentConfig: {
    type: Object,
    default: () => ({}),
  },
  filterConfig: {
    type: Object,
    default: () => ({}),
  },
  formElements: {
    type: Object,
    default: () => ({}),
  },
});
// ---------------------------------- Props --------------------------------- //

// ---------------------------------- Emits --------------------------------- //

// ---------------------------- Injects/Provides ---------------------------- //

// ----------------------- Variables - Pinia - consts ----------------------- //

// --------------------- Variables - Pinia - storeToRefs -------------------- //

// ------------------- Variables - Local - consts and lets ------------------ //

// ------------------------ Variables - Local - refs ------------------------ //

// ---------------------- Variables - Local - reactives --------------------- //

// --------------------------- Computed properties -------------------------- //

// -------------------------------- Functions ------------------------------- //

// -------------------------------- Watchers -------------------------------- //

// ----------------------------- Lifecycle Hooks ---------------------------- //
onMounted(() => {
  // console.log('Single Input Operator Component Loaded', props);
  nextTick(() => {
    props.formElements.operator_value?.input?.focus();
  });
});
</script>

<template>
  <div>
    <TextElement
      name="operator_value"
      :placeholder=" $t('Enter value')"
      v-bind="componentConfig"
      input-type="number"
      autocomplete="off"
      :default="filterConfig?.operator_value || null"
      @keydown.space.stop
    />
  </div>
</template>

<style scoped lang="scss">

</style>
